<template>
    <div class="item col-sm-4 col-lg-4 col-md-4"
         style="height: 320px !important; margin-bottom: 10px; padding: 10px">
        <div class="product" style="height: 320px; margin-bottom: 5px">
            <div class="image" style="padding:5px !important;">
                <a
                        v-on:click.prevent="addFilter(menu, type, parent)"
                        v-bind:href="buildUrl(menu, type, parent)"
                >
                    <img
                            v-if="menu.attachment"
                            :src="'/' + menu.attachment.url + '?fit=fill&w=200&h=200'"
                            class="img-responsive"
                    />
                </a>
            </div>
            <div class="description" style="word-wrap: break-word; width: 200px">
                <h4>
                    <a
                            v-on:click.prevent="addFilter(menu, type, parent)"
                            v-bind:href="buildUrl(menu, type, parent)"
                    >
                        {{menu.description | striphtml}}
                    </a>
                </h4>
                <p class="small" v-html="menu.truncated_description"></p>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'menu-card-item',
        props: ['menu', 'type', 'parent'],
        methods: {

            addFilter: function (filter, type, parent) {


                let queryFilter = {
                    [filter.key]: filter.slug ? filter.slug : filter.code
                };

                if (typeof parent !== 'undefined') {
                    queryFilter = {[parent.key]: parent.slug ? parent.slug : parent.code, ...queryFilter}
                }
                this.$parent.queryParams = {...this.$parent.queryParams, ...queryFilter};
                this.$parent.currentPage = 1;
                this.$parent.queryParams = {...this.$parent.queryParams, ...{page: this.$parent.currentPage}};

                this.$parent._setRoute();
            },
            buildUrl: function (filter, type, parent) {

                let queryFilter = {
                    [filter.key]: filter.slug ? filter.slug : filter.code
                };

                if (typeof parent !== 'undefined') {
                    queryFilter = {[parent.key]: parent.slug ? parent.slug : parent.code, ...queryFilter}
                }

                let queryParams = {...this.$parent.queryParams, ...queryFilter};


                return '/' + queryParams.lang + '/' + queryParams.top + '/' + queryParams.category + (queryParams.group ? '/' + queryParams.group : '');
            }
        },
    }
</script>

<style scoped>

</style>
